export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PaymentModal.vue?vue&type=template&id=10ab44f7&"


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentModal.vue?vue&type=template&id=10ab44f7&
// module id = 545
// module chunks = 0